<template>
  <nav class="navbar">
    <grid-container>
      <grid-row class="navbar__inner">
        <div class="navbar__logo"><logo-container/></div>
        <div class="navbar__hamburger"><slot name="hamburger"/></div>

        <div class="navbar__description">
          <border-box type="secondary">
            <p>
              Comprehensive solutions <br>
              in the field of urban planning <br>
              and architecture
            </p>
          </border-box>
        </div>

        <div class="navbar__menu navbar__menu--st">
          <border-box type="secondary"><slot name="left-menu"/></border-box>
        </div>

        <div class="navbar__menu navbar__menu--nd">
          <border-box type="secondary"><slot name="right-menu"/></border-box>
        </div>
      </grid-row>
      <div class="navbar__switcher"><theme-switcher-container/></div>
    </grid-container>
  </nav>
</template>

<script>
import LogoContainer from '@/containers/Navigation/LogoContainer'
import BorderBox from '@/components/BorderBox'
import ThemeSwitcherContainer from '@/containers/Navigation/ThemeSwitcherContainer'

export default {
  components: {
    LogoContainer,
    BorderBox,
    ThemeSwitcherContainer
  }
}
</script>

<style lang="scss" scoped>
  .navbar {
    @include text(normal, bold);
    position: relative;
    z-index: z(navbar);

    padding-top: 38px;
    padding-bottom: 48px;

    &__inner {
      position: relative;
      @include media-down(md) {
        justify-content: space-between;
      }
    }

    &__logo {
      @include grid-column((md: 6, lg: 3));
      @include column-width(196px + $grid-gutter / 2);
      margin-top: -$border-width;

      @include media-down(md) {
        padding-right: 0;
      }

      transition: width .4s, flex-basis .4s, max-width .4s;
    }

    &__hamburger {
      @include grid-column;
      @include hide-up(md);
      @include column-width(64px + $grid-gutter);
    }

    &__description {
      @include grid-column((lg: 4));
      @include grid-offset((lg: 3));
      @include text(normal, bold);

      position: absolute;
      left: 0;
      top: 0;

      pointer-events: none;
      opacity: 0;

      @include media-up(lg) {
        opacity: 1;
        pointer-events: auto;
        transition: opacity .4s ease .4s;
      }
    }

    &__menu {
      @include hide-down(md);

      &--st {
        @include grid-column((md: 3, lg: 2));
        @include grid-offset((lg: 4));
        @include media-up(lg) {
          transition: margin .4s;
        }
      }

      &--nd {
        @include grid-column((md: 3, lg: 3))
      }
    }

    &__switcher {
      @include hide-down(md);
      display: flex;
      justify-content: flex-end;
      padding-top: 190px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Navigation/Navbar.vue